import localization from "store/modules/LocalizationModule";
import assistant from "store/modules/AssistantModule";
import contact from "store/modules/ContactModule";

window.vueXStore = window.vueXStore || new Vuex.Store({strict:true});

window.vueXStore.registerModule("localization", localization);
window.vueXStore.registerModule("assistant", assistant);
window.vueXStore.registerModule("contact", contact);
